import { Application } from "@hotwired/stimulus";
import { Autocomplete } from "stimulus-autocomplete";
import "../utils/turboConfirm";

window.process = { env: { NODE_ENV: "production" } };

const application = Application.start();

// Configure Stimulus development experience
application.debug = true;
window.Stimulus = application;

application.register("autocomplete", Autocomplete);

window.testUtils = { requestsBlocked: false };

document.addEventListener("turbo:before-fetch-request", (event) => {
  if (window.testUtils) {
    if (window.testUtils.requestsBlocked) {
      event.preventDefault();
      return;
    }

    testUtils.pendingRequestsCount ||= 0;
    testUtils.pendingRequestsCount += 1;
  }
});

document.addEventListener("turbo:before-fetch-response", () => {
  if (testUtils?.pendingRequestsCount > 0) {
    testUtils.pendingRequestsCount -= 1;
  }
});
document.addEventListener("turbo:fetch-request-error", () => {
  if (testUtils?.pendingRequestsCount > 0) {
    testUtils.pendingRequestsCount -= 1;
  }
});

export { application };
